var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.isClient)?_c(_setup.ClientDetailPage):(_setup.isUserStaff)?_c(_setup.StaffDetailPage):(_setup.isUserConsultant)?_c(_setup.ConsultantDetailPage):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }